export default "__VITE_ASSET__DXnvISKA__"